import { setSlides } from "../slices/uniSlice";
import { CallAPI } from "../../apiManager/ApiCall";
import {
  getAddContentToSlidePresentationURL,
  getAddSlidePresentationByTitleIdURL,
  getAddSlidePresentationURL,
  getPublicSlidePresentationByTitleIdURL,
} from "../../apiManager/APIConfig";
import { store } from "../../redux/store";

export const AddSlideToPresentationCall = async (body) => {
  console.log(" pippo AddSlideToPresentationCall body", body);

  try {
    const response = await CallAPI({
      url: getAddSlidePresentationURL,
      method: "POST",
      body,
    });
    console.log(" pippo AddSlideToPresentationCall", response);

    if (body?.title_id) GetAllSlideWithContentByTitleId(body.title_id);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

export const AddContentToSlidePresentationCall = async (body) => {
  console.log(" pippo AddContentToSlidePresentationCall body", body);

  try {
    const response = await CallAPI({
      url: `${getAddContentToSlidePresentationURL}`,
      method: "POST",
      body,
    });
    console.log(" pippo AddContentToSlidePresentationCall", response);

    if (body?.title_id) GetAllSlideWithContentByTitleId(body.title_id);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};
export const EditContentToSlidePresentationCall = async (body) => {
  console.log(" pippo AddContentToSlidePresentationCall body", body);

  try {
    const response = await CallAPI({
      url: `${getAddContentToSlidePresentationURL}`,
      method: "PUT",
      body,
    });
    console.log(" pippo AddContentToSlidePresentationCall", response);

    if (body?.title_id) GetAllSlideWithContentByTitleId(body.title_id);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

export const GetAllSlideWithContent = async () => {
  try {
    const response = await CallAPI({
      url: `${getAddSlidePresentationURL}`,
      method: "GET",
    });
    console.log(" pippo GetAllSlideWithContent", response);

    // GetTitlesCall(body?.lang, body?.type);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

export const GetAllSlideWithContentByTitleId = async (titleId) => {
  if (!titleId || titleId === "undefined") {
    return { status: 400 };
  }
  try {
    const response = await CallAPI({
      url: `${getAddSlidePresentationByTitleIdURL}/${titleId}`,
      method: "GET",
    });
    const slides = response?.data?.data ?? response?.data ?? response;
    if (slides) {
      store.dispatch(setSlides(Array.isArray(slides) ? slides : []));
    }
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

// Public version used by mobile presentation viewer (no auth, only published)
export const GetPublishedSlidesWithContentByTitleIdPublic = async (titleId) => {
  if (!titleId || titleId === "undefined") {
    return { status: 400 };
  }
  try {
    const response = await CallAPI({
      url: `${getPublicSlidePresentationByTitleIdURL}/${titleId}`,
      method: "GET",
    });
    const slides = response?.data?.data ?? response?.data ?? response;
    if (slides) {
      store.dispatch(setSlides(Array.isArray(slides) ? slides : []));
    }
    return response;
  } catch (error) {
    return { status: 400 };
  }
};

export const DeletePresentationSlideCall = async (slideId, titleId) => {
  if (!slideId) return { status: 400 };
  try {
    const response = await CallAPI({
      url: `${getAddSlidePresentationURL}/${slideId}`,
      method: "DELETE",
    });
    if (titleId) await GetAllSlideWithContentByTitleId(titleId);
    return response;
  } catch (error) {
    return { status: 400 };
  }
};
